import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Navbar, Container } from 'react-bootstrap'
import tfbank21_logo_white from 'img/tf-logos/tfbank21-logo-white.svg'
import appConfig from 'app.config'
import { checkIsMobile, checkIsTablet } from 'shared'
import { appRoutes } from 'selfServicePortal/constants/routes'
import {
	IMenuDropdownItem,
	menuItems,
} from 'selfServicePortal/constants/menuItems'
import SspContext from 'selfServicePortal/contexts/SspContext'
import Menu from './../Menu/Menu'
import './HeaderSsp.scss'

const InfoContainer = () => {
	const { t } = useTranslation()
	const isMobile = checkIsMobile()
	const { staticCountryValues, productType } = useContext(SspContext)

	return (
		<div className="info d-flex align-items-center">
			{!isMobile && (
				<>
					{staticCountryValues?.productSpecific.map((value, key) => {
						if (value.productType === productType) {
							return (
								<a
									key={'contact-info-' + key}
									className="d-flex align-items-center"
									href={`mailto:${value.contactInformation.email}`}>
									<span className="envelope mr-2"></span>
									{value.contactInformation.email}
								</a>
							)
						}
						return null
					})}
					<Link className="ml-5 btn btn-info" to={appRoutes.logout}>
						{t('SignOut')}
					</Link>
				</>
			)}
		</div>
	)
}

const HeaderSsp = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false)
	const isMobile = checkIsMobile()
	const isTablet = checkIsTablet()
	const { setComponent } = useContext(SspContext)

	useEffect(() => {
		window.addEventListener('scroll', resizeHeaderOnScroll)
		return () => {
			document.removeEventListener('scroll', resizeHeaderOnScroll)
		}
	}, [])

	const resizeHeaderOnScroll = () => {
		const distanceY =
			window.pageYOffset || document.documentElement.scrollTop
		const shrinkOn = 100
		const headerEl = document.getElementById('hero')
		const menuEl = document.getElementById('menu')

		if (headerEl && menuEl) {
			if (distanceY > shrinkOn) {
				menuEl.classList.add('top')
				headerEl.classList.add('hide-hero')
			} else {
				menuEl.classList.remove('top')
				headerEl.classList.remove('hide-hero')
			}
		}
	}

	const changeComponent = useCallback(
		(clickedItem: IMenuDropdownItem) => {
			menuItems.forEach((menuItem) => {
				menuItem.items.forEach((item) => {
					setComponent({
						...item,
						show: false,
					})
				})
			})

			setComponent({
				...clickedItem,
				show: true,
			})
		},
		[setComponent],
	)

	return (
		<div className="header-ssp">
			<Navbar
				className={`header ${isTablet ? 'tablet-header' : ''}`}
				expanded={isMenuOpen}
				expand={false}>
				<Container className="p-3 d-flex justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						<Navbar.Brand
							onClick={() =>
								changeComponent(menuItems[0].items[0])
							}
							className="pointer"
							data-cy="headerLogo">
							<img
								src={tfbank21_logo_white}
								className="logo"
								alt="logo"
							/>
						</Navbar.Brand>
					</div>
					<Navbar.Toggle
						aria-controls="basic-navbar-nav"
						className="me-3 d-md-none"
						onClick={() => setIsMenuOpen(!isMenuOpen)}
					/>
					<InfoContainer />
				</Container>
			</Navbar>

			{!isMobile && (
				<div
					id="hero"
					className={
						appConfig.country === 'at' || appConfig.country === 'de'
							? `hero ${appConfig.country}-hero container`
							: 'hero container'
					}>
					<div className="inner"></div>
				</div>
			)}

			<Menu
				changeComponent={changeComponent}
				isMenuOpen={isMenuOpen}
				setIsMenuOpen={setIsMenuOpen}
				data-cy="headerMenu"
			/>
		</div>
	)
}

export default HeaderSsp
